import '../bms.scss'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { startSxpProxy } from '../../../utils/api'
import { IPD_PROJECT_ID, pageSizeOptions } from '../../../utils/constants'
import {
  emptyString,
  noData,
  toastOptions,
} from '../../Radiology/Constants/constants'
import {
  BedType,
  bedFilter,
  comparisionOccupiedText,
  dropDownStatusIpd,
  filterType,
} from '../constants'
import { allocateApi, allocation, errorMessages } from '../modals'
import KeycloakService from '../../../utils/keycloakService'
import AddDischargeDialog from '../dialog/AddDischargeDialog'
import EditDischargeDate from '../dialog/EditDischargeDate'
import Dialog from '../../../components/Dialog'
import RemarksText from '../dialog/RemarksText'
import EditRemarksText from '../dialog/EditRemarksText'
import { ipVisitApi } from '../models'
import { toast } from 'react-toastify'
import ToastMessage from '../../lms/components/ToastMessage'
import { Box, styled } from '@mui/system'
import Edit from '../../../assets/icons/edit_icon.svg'
import { IPD_DISCHARGE_ADMIN } from '../../../utils/roles'
import { ColDef } from 'ag-grid-community'
import MedAgDataGrid from '../../../components/MedAgDataGrid'
import CustomHeader from '../../Radiology/components/RadiologyModel/CustomHeader'
import LocationFilter from './LocationFilter'
import useCustomStyles from '../../../utils/hooks/CustomStylesHook'
import { useTheme } from '@mui/material'
import { radiologyColor } from '../../Radiology/Utils/RadiologyColors'
import { getBedsByLocationForAllocation } from '../../../services/IPDService'
import DropdownMenu from '../../../components/DropdownMenu/DropdownMenu'
import { exportExcel } from '../../../utils/hooks/Utils'
import { dropDownMenuKeys, noDataMessage } from '../../../components/constants'
import SelectableSearch from '../../../components/SelectableSearch'

interface StatusBoxProps {
  status?: string
}
const StatusBox = styled('div')<StatusBoxProps>(({ status }) => ({
  backgroundColor: status === 'AVAILABLE' ? 'green' : '#f47421',
  color: 'white',
  padding: '5px',
  borderRadius: '3px',
  cursor: status === allocation?.occupied ? 'pointer' : '',
  '&:hover': {
    backgroundColor: status === allocation?.available ? '' : '#f38c4c',
  },
}))

const styles = () => ({
  centerHeader: {
    color: radiologyColor?.white,
    textAlign: 'center',
    '& .ag-header-cell-text': {
      flex: 1,
    },
  },
})
const BedManagement = () => {
  const navigate = useNavigate()
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const [locationName, setLocationName] = useState('Amalapuram')
  const [isAllocateOpen, setIsAllocateOpen] = useState<boolean>(false)
  const [refresh, setRefresh] = useState<boolean>(false)
  const [patientAllocate, setPatientAllocate] = useState<boolean>(false)
  // const [wardDetails, setWardDetails] = useState<wards[]>([])
  const [activeIndex, setActiveIndex] = useState(-1)
  // const [isEditDoctor, setIsEditDoctor] = useState(false)
  const [isEditRemarks, setIsEditRemarks] = useState(false)
  const [assignedDoctor, setAssignedDoctor] = useState('')
  const [expandedId, setExpandedId] = useState(null)
  const [selectedDate, setSelectedDate] = useState('')
  const [loading, setLoading] = useState(false)
  const [wardId, setWardId] = useState<bedFilter>({
    id: '',
    patientId: '',
    patientName: '',
    bedNumber: '',
    bedCategory: 0,
    roomDetail: '',
    status: '',
    admission: '',
    dischargedDate: '',
    ward: 0,
    wardName: '',
    floorNumber: '',
    locationId: '',
    patientAssignmentMap: [],
    patientRegisteredId: '',
    assignedDoctor: '',
  })
  const [bedTable, setBedTable] = useState<bedFilter[]>([])
  const [filter, setFilter] = useState<filterType>({
    patientUhid: '',
    status: '',
    ward: '',
    category: '',
  })
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    setTimeout(
      () =>
        setFilter((prevState) => ({
          ...prevState,
          patientUhid: '',
          status: '',
          ward: '',
          category: '',
        })),
      5000
    )
  }, [locationName])
  const [patientId, setPatientId] = useState('')
  const dateObject = (dateString: string) => {
    const dateObject = new Date(dateString)
    const formattedDate = dateObject.toISOString().split('T')[0]
    return formattedDate
  }

  const filtered = useMemo(() => {
    if (
      filter?.status === emptyString &&
      filter?.ward === emptyString &&
      filter?.patientUhid === emptyString &&
      filter?.category === emptyString
    ) {
      return bedTable
    }
    return bedTable?.filter((item: bedFilter) => {
      return (
        (filter.status === emptyString || item.status === filter.status) &&
        (filter.ward === emptyString || item.wardName === filter.ward) &&
        (filter.patientUhid === emptyString ||
          item.patientId
            ?.toLowerCase()
            ?.startsWith(filter?.patientUhid?.toLowerCase())) &&
        (filter?.category === emptyString ||
          item?.bedCategory === filter?.category)
      )
    })
  }, [
    bedTable,
    filter?.status,
    filter?.ward,
    filter?.patientUhid,
    filter?.category,
  ])
  useEffect(() => {
    startSxpProxy(IPD_PROJECT_ID, allocateApi.getWardsByLocation, {
      locationId: locationName,
    })?.then(() => {
      // const wards = data?.data?.ward_details?.map((e: WardDetail) => {
      //   const id = e?.id
      //   const name = e?.ward_name
      //   return {
      //     id,
      //     name,
      //   }
      // })
      // setWardDetails(wards)
    })
  }, [locationName])
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(100)
  const [totalCount, setTotalCount] = useState(0)
  const tableRefresh = async () => {
    setLoading(true)
    const response = await getBedsByLocationForAllocation(
      pageSize,
      page,
      locationName,
      searchTerm
    )
    if (response?.success) {
      if (response?.data?.bed?.length > 0) {
        const bedData = response?.data?.bed?.map((e: BedType) => {
          const id = e?.id
          const patientId = e?.patient_id ?? ''
          const patientName = e?.patient_name ?? '-'
          const bedNumber = e?.bed_number
          const locationId = e?.location_id
          const bedCategory = e.bed_category?.name
          const roomDetail = `${e?.room_detail?.room_name} ${
            e?.room_detail?.room_number ?? ''
          }`
          const status = e?.status
          const patientAssignmentMap = e?.bed_patient_assignment_maps
          const assignedDoctor = e?.bed_patient_assignment_maps
          const admission = e?.admission_date
          const dischargedDate = e?.discharged_date ?? ''
          const ward = e?.room_detail?.ward_id
          const wardName = e?.room_detail?.ward_detail?.ward_name
          const floorNumber = e?.room_detail?.floor_number
          return {
            id: id,
            patientId: patientId,
            patientName: patientName,
            bedNumber: bedNumber,
            bedCategory: bedCategory,
            roomDetail: roomDetail,
            status: status,
            admission: admission,
            dischargedDate,
            patientAssignmentMap,
            ward,
            wardName,
            floorNumber,
            locationId,
            assignedDoctor,
          }
        })
        setBedTable(bedData)
        setTotalCount(response?.data?.bed_aggregate?.aggregate?.count)
        setLoading(false)
      } else {
        setBedTable([])
        setTotalCount(0)
        setLoading(false)
      }
      toast.success(response?.message)
    } else {
      setBedTable([])
      setTotalCount(0)
      setLoading(false)
      toast.error(response?.message)
    }
  }
  useEffect(() => {
    tableRefresh()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationName, page, pageSize, refresh, searchTerm])
  useEffect(() => {
    if (patientId !== emptyString) {
      const state = {
        id: parseInt(wardId.id),
        status: allocation.occupied,
        patientId: patientId,
        createdBy: KeycloakService?.getUsername(),
        admissionDate: selectedDate ? selectedDate : new Date().toISOString(),
        dateCreated: new Date().toISOString(),
        patientName: wardId.patientName ?? emptyString,
        assignedDoctor: assignedDoctor,
        patientRegisteredId: wardId.patientRegisteredId,
      }
      startSxpProxy(IPD_PROJECT_ID, allocateApi?.createAndUpdateBed, state)
        ?.then(() => {
          startSxpProxy(IPD_PROJECT_ID, ipVisitApi?.masterEncounter, {
            patientId: wardId?.patientRegisteredId,
          })
            .then(() => {
              setWardId((prevBed: any) => ({
                ...prevBed,
                patientName: '',
                patientId: '',
                gender: '',
                age: '',
              }))
              navigate('/bedIpd')
              setPatientId('')
              setSelectedDate('')
              setAssignedDoctor('')
              setRefresh(true)
            })
            .catch((err) => console.error(err))
        })
        .catch((err) => {
          console.error(err, 'err')
          toast.error(
            <ToastMessage
              message={err?.response?.data?.message ?? 'Unable to fetch api'}
            />,
            toastOptions
          )
          setPatientId('')
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    patientId,
    wardId.id,
    navigate,
    wardId.patientName,
    wardId.patientRegisteredId,
    assignedDoctor,
  ])

  const handleRemarksEdit = (i: number) => {
    // setIsEditDoctor(false)
    setIsEditRemarks(true)
    setActiveIndex(i)
  }

  const handleAllocateClose = () => {
    setIsAllocateOpen(false)
  }
  const handleAllocatePatientClose = () => {
    setPatientAllocate(false)
  }
  const handleDischargeConfirm = (e: boolean) => {
    setIsAllocateOpen(e)
    setRefresh(!e)
  }

  // const handleAllocateConfirm = (
  //   e: boolean,
  //   bed: bedFilter,
  //   doctor?: any,
  //   date?: any
  // ) => {
  //   setIsAllocateOpen(e)
  //   setWardId(bed)
  //   setAssignedDoctor(doctor)
  //   setPatientId(bed?.patientId)
  //   setSelectedDate(date)
  // }

  const handleAllocate = (event: any, e: boolean, i: bedFilter) => {
    event.preventDefault()
    event.stopPropagation()
    setWardId(i)
    setIsAllocateOpen(e)
  }
  const handlePatientAllocate = (e: boolean) => {
    setPatientAllocate(e)
    setRefresh((prevState: boolean) => !prevState)
  }
  const toggleExpanded = (id: any) => {
    setExpanded(true)
    setExpandedId(expandedId === id ? null : id)
  }

  const handleRemarksChange = (d: bedFilter, remarks: string) => {
    setIsEditRemarks(false)
    setActiveIndex(-1)
    const state = {
      id: parseInt(d?.assignedDoctor?.[0]?.id),
      bedId: d?.id,
      patientId: d?.patientId,
      remarks: remarks,
      assignedDoctor: d?.assignedDoctor?.[0]?.assigned_doctor ?? '',
    }
    startSxpProxy(
      IPD_PROJECT_ID,
      allocateApi?.editBedPatientAssignment,
      state
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ).then((_) => {
      tableRefresh()
    })
  }
  const getDoctorName = (e: any) => {
    const doctorName = e?.patientAssignmentMap
    return e?.status === allocation?.occupied &&
      doctorName?.some(
        (item: any) =>
          item?.bed_status === allocation?.assigned &&
          item?.patient_id === e?.patientId
      )
      ? doctorName?.find(
          (item: any) =>
            item?.bed_status === allocation?.assigned &&
            item?.patient_id === e?.patientId
        )?.assigned_doctor
      : noData
  }
  const handleRow = (bed: any) => {
    const state = {
      id: parseInt(bed?.id),
      status: allocation?.available,
      patientId: null,
      patientName: null,
      admissionDate: null,
    }
    startSxpProxy(
      IPD_PROJECT_ID,
      allocateApi?.newUpdateBedforDischargedPatient,
      state
    )
      .then((data) => {
        toast.success(
          `Updated ${data?.data?.update_bed_by_pk?.bed_number} Successfully`
        )
        tableRefresh()
      })
      .catch(() => {
        toast.error(errorMessages?.fetchingError)
      })
  }

  const patientTableContainerRef = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    const resizeHandler = () => {
      const container = patientTableContainerRef.current
      if (container) {
        const availableHeight: any =
          window.innerHeight - container?.getBoundingClientRect().top
        container.style.maxHeight = `${availableHeight - 60}px`
      }
    }

    window.addEventListener('resize', resizeHandler)
    resizeHandler()

    return () => {
      window.removeEventListener('resize', resizeHandler)
    }
  }, [])
  useEffect(() => {
    setPage(0)
    setPageSize(100)
  }, [locationName])
  const [expanded, setExpanded] = useState(false)
  const handleSearch = (query: string, param: string) => {
    setSearchTerm(param)
  }
  const columns: ColDef[] = [
    {
      headerName: 'Bed No',
      field: 'bedNo',
      minWidth: 200,
      sortable: false,
      filter: true,
      headerComponent: CustomHeader,
      cellRenderer: (params: any) => {
        const filteredRow = filtered?.find(
          (row) => row?.id === params?.data?.id
        )
        if (!filteredRow) {
          return null
        }
        return (
          <>
            <StatusBox
              status={filteredRow?.status}
              onClick={(e) => handleAllocate(e, true, filteredRow)}
            >
              <span
                className={`${
                  filteredRow?.status === allocation?.occupied
                    ? 'hover-pointer'
                    : 'no-hover-pointer'
                }`}
              >
                {filteredRow?.bedNumber ?? ''}
              </span>
            </StatusBox>
          </>
        )
      },
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', padding: '1px' },
      resizable: false,
      pinned: 'left',
      lockPinned: true,
    },
    {
      headerName: 'Ward/Room',
      field: 'wardRoom',
      minWidth: 300,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) => {
        const filteredRow = filtered?.find(
          (row) => row?.id === params?.data?.id
        )
        return (
          <StatusBox status={filteredRow?.status}>
            {filteredRow ? filteredRow?.roomDetail : 'N/A'}
          </StatusBox>
        )
      },
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', padding: '1px' },
      resizable: false,
      pinned: 'left',
      lockPinned: true,
    },
    {
      headerName: 'BedType',
      field: 'bedType',
      flex: 1,
      minWidth: 140,
      sortable: false,
      filter: false,
      headerComponent: CustomHeader,
      cellRenderer: (params: any) => {
        const filteredRow = filtered?.find(
          (row) => row?.id === params?.data?.id
        )

        return (
          <StatusBox status={filteredRow?.status}>
            {filteredRow ? filteredRow?.bedCategory : 'N/A'}
          </StatusBox>
        )
      },
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', padding: '1px' },
      resizable: false,
      pinned: 'left',
      lockPinned: true,
    },
    {
      headerName: 'Status',
      field: 'primary',
      minWidth: 80,
      sortable: true,
      filter: true,
      cellRenderer: (params: any) => {
        const filteredRow = filtered?.find((row) => row?.id === params?.data.id)

        return (
          <>
            <StatusBox status={filteredRow?.status}>
              {filteredRow?.status === allocation?.available
                ? allocation?.availableCase
                : allocation?.occupiedCase}
            </StatusBox>
          </>
        )
      },
      headerComponent: CustomHeader,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        padding: '1px',
      },
      wrapText: true,
      resizable: false,
      pinned: 'left',
      lockPinned: true,
    },
    {
      headerName: 'UHID',
      field: 'uhid',
      minWidth: 120,
      sortable: false,
      filter: true,
      headerComponent: CustomHeader,
      cellRenderer: (params: any) => {
        const patientObj = params?.row?.patientObject?.find(
          (e: any) => e?.patient_id === params?.data?.uhid
        )
        const statusCheck =
          (!params?.data?.patientObject?.[0] ||
            (patientObj &&
              patientObj?.bed_status === allocation?.dischargedText)) &&
          (params?.data?.status === allocation?.occupiedCase ||
            params?.data?.status === allocation?.occupied)

        return (
          <>
            <div className='bed-error-uhid-container'>
              <span>{params?.data?.uhid}</span>
              {statusCheck &&
                KeycloakService?.hasRole([IPD_DISCHARGE_ADMIN]) && (
                  <img
                    src={Edit}
                    className='bed-error-discharge'
                    onClick={() => handleRow(params?.data)}
                    title='Discharge'
                  />
                )}
            </div>
          </>
        )
      },
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
      resizable: false,
      pinned: 'left',
      lockPinned: true,
    },
    {
      headerName: 'Patient Name',
      field: 'name',
      minWidth: 200,
      sortable: false,
      filter: false,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        padding: '1px',
        textAlign: 'left',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.5,
        display: 'flex',
        alignItems: 'center',
      },
      wrapText: true,
      resizable: false,
      pinned: 'left',
      lockPinned: true,
    },
    {
      headerName: 'Primary Doctor Name',
      field: 'doctorName',
      minWidth: 200,
      sortable: true,
      filter: true,
      headerComponent: CustomHeader,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        padding: '1px',
        textAlign: 'left',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.5,
        display: 'flex',
        alignItems: 'center',
      },
      wrapText: true,
    },
    {
      headerName: 'Admission Date',
      field: 'admission',
      flex: 1,
      minWidth: 170,
      sortable: true,
      filter: true,
      headerComponent: CustomHeader,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'left',
      },
      wrapText: true,
    },
    {
      headerName: 'AdditionalInfo',
      field: 'status',
      minWidth: 255,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) => {
        const filteredRow = filtered?.find(
          (row) => row?.id === params?.data?.id
        )
        if (!filteredRow) return null
        const rowIndex = rows?.findIndex((row) => row?.id === params?.data?.id)
        const isOccupied = filteredRow?.status === allocation?.occupied
        return (
          <div className={`${isOccupied ? 'hover-occupied' : 'invalid-hover'}`}>
            {isOccupied && (
              <>
                {isEditRemarks && rowIndex === activeIndex ? (
                  <>
                    <EditRemarksText
                      data={filteredRow}
                      id={rowIndex}
                      onChange={handleRemarksChange}
                    />
                  </>
                ) : (
                  <span onClick={() => handleRemarksEdit(rowIndex)}>
                    {filteredRow?.assignedDoctor?.length === 0 ? (
                      allocation?.addRemarks
                    ) : filteredRow?.assignedDoctor[0]?.remarks ? (
                      <RemarksText
                        text={filteredRow?.assignedDoctor[0]?.remarks}
                        expanded={expandedId === filteredRow?.id && expanded}
                      />
                    ) : (
                      allocation?.addRemarks
                    )}
                  </span>
                )}
                {isEditRemarks === false &&
                filteredRow?.assignedDoctor[0]?.remarks?.length > 10 ? (
                  <span
                    className='view-more'
                    onClick={() => toggleExpanded(filteredRow?.id)}
                  >
                    {expandedId === filteredRow?.id
                      ? allocation?.viewLess
                      : allocation?.viewMore}
                  </span>
                ) : null}
              </>
            )}
          </div>
        )
      },
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        display: 'flex',
        alignItems: 'center',
      },
      wrapText: true,
    },
  ]
  const rows = filtered?.map((d) => ({
    id: d?.id,
    bedNo: d?.bedNumber,
    ward: d?.roomDetail,
    bedType: d?.bedCategory,
    status: d?.status === 'AVAILABLE' ? 'Available' : 'Occupied',
    uhid: d?.patientId || allocation.hyphen,
    name: d?.patientName || allocation.hyphen,
    doctorName: getDoctorName(d),
    patientObject: d?.patientAssignmentMap,
    admission: d?.admission ? dateObject(d?.admission) : allocation?.hyphen,
    discharge: allocation?.hyphen,
    additionalInfo: allocation?.addRemarks,
  }))
  const getModifiedRows = (rows: any) => {
    const modifiedRows = [...rows]?.sort((a, b) => {
      if (
        a?.status === comparisionOccupiedText &&
        b?.status !== comparisionOccupiedText
      )
        return -1
      if (
        a?.status !== comparisionOccupiedText &&
        b?.status === comparisionOccupiedText
      )
        return 1
      return 0
    })
    return modifiedRows
  }
  const handleExport = () => {
    if (getModifiedRows(rows)?.length > 0) {
      exportExcel(getModifiedRows(rows))
    } else {
      toast.error(noDataMessage)
    }
  }
  const handleSelected = (e: any) => {
    if (e?.[0] === dropDownMenuKeys?.export) {
      handleExport()
    }
  }
  return (
    <>
      {patientAllocate && (
        <Dialog
          open={patientAllocate}
          onClose={handleAllocatePatientClose}
          style={{ width: '50%', padding: '1%' }}
        >
          <EditDischargeDate
            onClose={() => setPatientAllocate(false)}
            onConfirm={handlePatientAllocate}
            wardId={wardId}
          />
        </Dialog>
      )}

      {/* {isAllocateOpen && wardId.status === allocation.available && (
        <Modal open={isAllocateOpen} onClose={handleAllocateClose}>
          <Box sx={style}>
            <AddAlllocationDialog
              onClose={() => setIsAllocateOpen(false)}
              onConfirm={handleAllocateConfirm}
              wardId={wardId}
            />
          </Box>
        </Modal>
      )} */}

      {isAllocateOpen && wardId.status === allocation.occupied && (
        <Dialog
          open={isAllocateOpen}
          onClose={handleAllocateClose}
          style={{ width: '67%' }}
        >
          <AddDischargeDialog
            onConfirm={handleDischargeConfirm}
            wardId={wardId}
            setRefresh={setRefresh}
            onClose={() => setIsAllocateOpen(false)}
            refresh={refresh}
            tableRefresh={tableRefresh}
            mode='list'
          />
        </Dialog>
      )}
      <Box height={'100%'} width={'100%'}>
        <MedAgDataGrid
          tableHeight={'100%'}
          columns={columns}
          rowData={getModifiedRows(rows)}
          columnDefs={columns}
          pagination={true}
          pageSizeOptions={pageSizeOptions}
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          totalRows={totalCount}
          headerHeight={30}
          rowHeight={35}
          loading={loading}
          tableHeading={'Bed Allocation'}
          exportIcon={false}
          searchBeforeActions={
            <DropdownMenu
              onSelect={handleSelected}
              filterOptions={[
                {
                  label: dropDownStatusIpd?.selectLocationKey,
                  value: dropDownStatusIpd?.selectLocation,
                  customRender: (
                    <LocationFilter
                      locationName={locationName}
                      setLocationName={setLocationName}
                    />
                  ),
                },
              ]}
              actionOptions={[
                {
                  label: dropDownMenuKeys?.exportKey,
                  value: dropDownMenuKeys?.export,
                },
              ]}
              selectedId={false}
            />
          }
          filterActions={
            <>
              <SelectableSearch items={['MUHID']} onSearch={handleSearch} />
              <LocationFilter
                locationName={locationName}
                setLocationName={setLocationName}
              />
            </>
          }
          searchField={false}
        />
      </Box>
    </>
  )
}
export default BedManagement
